<script>
import Nav from "@/components/Nav/index.vue";
import Guide from "@/components/Guide/index.vue";
import liff from "@line/liff";
import { nextTick } from "vue";
import JsBarcode from "jsbarcode";
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import { Pagination, Autoplay } from 'swiper'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
export default {
    name: "Home",
    data() {
        return {
            descriptionTarget: "",
            isActiveEvent: true,
            popup: false,
            popup2: false,
            swiper: null
        };
    },
    components: {
        Nav,
        Guide,
        Swiper, 
        SwiperSlide
    },
    setup() {
        return {
            modules: [Pagination, Autoplay]
        }
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
        migoLiffId() {
            return this.$store.state.migoLiffId;
        },
        shopBaseUri() {
            return process.env.VUE_APP_shopLiffUri;
        },
    },
    watch: {
        userNbInfo: function () {
            let vm = this;
            if (!vm.userNbInfo.data.user.isBind) {
                vm.$router.push("/welcome");
            } else {
                nextTick(() => {
                    vm.initJsBarcode();
                    let progessLine =
                        (vm.userNbInfo.data.user.consumeNow /
                            vm.userNbInfo.data.user.consumeGoal) *
                        100;
                    if (progessLine >= 100) {
                        progessLine = 100;
                    }
                    document.documentElement.style.setProperty(
                        "--progessLine",
                        `${progessLine}%`
                    );
                });
            }
        },
    },
    mounted() {
        nextTick(() => {
            let vm = this;
            if (vm.userNbInfo.data) {
                if (vm.userNbInfo.data.user.isBind) {
                    vm.initJsBarcode();
                } else vm.$router.push("/welcome");
            }
            let start = "2024-09-08 00:00";
            let now = new Date();
            let reg = new RegExp("-", "g");

            if (new Date(start.replace(reg, "/")) <= now) {
                vm.isActiveEvent = false;
            }
        });
        const urlParams = new URLSearchParams(window.location.search);
        const maintenance = urlParams.get("maintenance")
        console.log(maintenance)
        if(maintenance==1){
            this.popup = true
        }
    },
    methods: {
        sendGtm(str) {
            window.dataLayer.push({
                event: "horyuken_event",
                event_name: str,
                event_time: new Date().toLocaleString(),
            });
        },
        initJsBarcode() {
            // console.log("JsBarcode");
            let vm = this;
            JsBarcode("#barcode", vm.userNbInfo.data.user.customId, {
                format: "CODE128",
                lineColor: "#151415",
                // width: 4.5,
                height: 60,
                displayValue: false,
                background: "transparent",
            });
        },
        showDescription(target) {
            // console.log("showDescription");
            let vm = this;
            if (target === vm.descriptionTarget) {
                vm.descriptionTarget = "";
            } else {
                vm.descriptionTarget = target;
            }
        },
        changeToLocaleString(str) {
            // console.log("changeToLocaleString", str);
            return typeof str === "number" ? str.toLocaleString() : "0";
        },
        goCoupon(item){
            this.$store.commit('setSelectedCouponItem', item);
            this.$router.push({
                name: 'CouponDetail',
                params: { id: item.coupon_no },
            });
        },
        upgradeAlert(){
            // document.querySelector('.popup').style.display = 'block'
            this.popup = true
        },
        closePopup(){
            // document.querySelector('.popup').style.display = 'none'
            this.popup = false
        },
        closeliff(){
            liff.closeWindow()
        }
    },
};
</script>
<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
